import { ENV_ENUM, getConfig } from '../configProvider';

export * from './date';

export function getRootDomain() {
    const hostname = window.location.hostname;
    // 分割域名为各个部分
    const parts = hostname.split('.').reverse();
    // 如果域名部分少于两个，直接返回
    if (parts.length < 2) {
        return hostname;
    }
    // 常见的二级顶级域名（ccTLDs）列表
    const commonTlds = ['co', 'com', 'org', 'net', 'gov', 'edu', 'mil'];
    // 获取根域名
    let rootDomain = parts[1] + '.' + parts[0];
    // 处理二级顶级域名情况
    if (commonTlds.includes(parts[1].toLowerCase()) && parts.length > 2) {
        rootDomain = parts[2] + '.' + rootDomain;
    }
    return rootDomain;
}

export const getSuffix = () => {
    const { env } = getConfig();
    let suffix = `--${env}`;
    if (env === ENV_ENUM.release) {
        suffix = '';
    }
    return suffix;
};

/**
 * 获取服务端真正需要上报的语言值
 * @param locale 语言
 * @returns
 */
export const getClientLanguage = (locale: string) => {
    const fankuiLangMap: any = {
        cn: 'zh-Hans',
        tw: 'zh-Hant',
        en: 'en',
        jp: 'ja',
        kr: 'ko',
        pt: 'pt',
        es: 'es',
        de: 'de',
        id: 'id',
        th: 'th',
        fr: 'fr',
        it: 'it',
        vi: 'vi',
        ja: 'ja',
        ko: 'ko',
        'zh-Hant': 'zh-Hant',
        'zh-Hans': 'zh-Hans',
    };

    return fankuiLangMap[locale] || '';
};

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
